import React from "react";
import Header from "./Components/Header/Header";
import Main from "./Components/Main/Main";
import Section from "./Components/Main/Section/Section";
import Newsfeed from "./Components/Main/Newsfeed/Newsfeed";
// import Footer from "./Components/Footer/Footer";
import Nav from "./Components/Main/Nav/Nav";
import './App.css';
import FriendsContainer from "./Components/Main/Friends/FriendsContainer";
import { Route, Routes} from "react-router-dom";
import Videos from "./Components/Main/Videos/Videos";
import Photos from "./Components/Main/Photos/Photos";
import UsersContainer from "./Components/Main/Users/UsersContainer";
import DialogsContainer from "./Components/Main/Dialogs/DialogsContainer";


function App() {
    return (
            <div className='wrapper'>
                <Header/>
                <Main>
                    <Nav/>
                    <Routes>
                        <Route exact path='/react/' element={<Newsfeed/>}/>
                        <Route path='react/profile' element={<Section />}/>
                        <Route path='react/newsfeed' element={<Newsfeed />}/>
                        <Route path='react/friends' element={<FriendsContainer />}/>
                        <Route exact path='react/dialogs/*' element={<DialogsContainer />}/>
                        <Route path='react/videos' element={<Videos/>}/>
                        <Route path='react/photos' element={<Photos />}/>
                        <Route path='/users' element={<UsersContainer />}/>
                    </Routes>
                </Main> 
                {/*<Footer/>*/}
            </div>
    );
}

export default App;

